import { render, staticRenderFns } from "./followWx.vue?vue&type=template&id=42061e52&scoped=true&"
import script from "./followWx.vue?vue&type=script&lang=js&"
export * from "./followWx.vue?vue&type=script&lang=js&"
import style0 from "./followWx.vue?vue&type=style&index=0&id=42061e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42061e52",
  null
  
)

export default component.exports